import { useEffect, useState } from "react";
// import OutsideClickHandler from "react-outside-click-handler";
import Popup from "./Popup";
import {
  fetchInternshipApplications,
} from "../../lib/data";

import search from "../../images/svg/search.svg";
import loader from "../../images/gif/loader-purple.gif";
import { useNavigate } from "react-router-dom";
import { FaIdCard } from "react-icons/fa";

function Itapplicants({ displayPage }) {
  // const [batchUsers, setBatchBUsers] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [date, setDate] = useState("");
  // const [showFilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formAction, setFormAction] = useState("Send to");
  const [users, setUsers] = useState([]);
  const [showEditor, setShowEditor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showPagination, setShowPagination] = useState(true);
  const [activeButton, setActiveButton] = useState(false);
  const [downloadBtn, setDownloadBtn] = useState(false);
  const [selectAll, setSelectAll] = useState(null);
  // const [duration, setDuration] = useState("");
  const [selectId, setSelectId] = useState([]);
  // const [checkAll, setCheckAll] = useState(false)

  const navigate = useNavigate();


  useEffect(() => {
    const d = new Date();
    setYear(d.getFullYear());
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let monthh = months[d.getMonth()];
    setMonth(monthh);
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let dayss = days[d.getDay()];
    setDay(dayss);
    const dates = d.getDate();
    if (dates === 1 || dates === 21 || dates === 31) {
      setDate(`${dates}st`);
    } else if (dates === 2 || dates === 22) {
      setDate(`${dates}nd`);
    } else {
      setDate(`${dates}th`);
    }
  }, [page]);

  useEffect(() => {
    getUsersall()
  }, []);

  const getUsersall = () => {
    setLoading(true);
    fetchInternshipApplications()
      .then((response) => response.data)
      .then((resp) => {
        // console.log("Internship Applications Response:", resp);
        if (resp.status === 200) {
          setUsers(resp.data);
          setLoading(false);
          setShowPagination(true);
        } else {
          console.warn("API returned success: false", resp);
          setLoading(false);
        }
      })

      .catch((err) => {
        setLoading(false);
        // console.log(err);
        // window.location.reload();
      });
  };

  const openModal = (par1) => {
    setFormAction(par1);
    setShowModal(true);
  };

  const paginate = (type) => {
    setLoading(true);
    if (type === "prev") {
      if (page > 0) {
        setPage(page - 1);
        getUsersall();
      }
    } else {
      if (page < 10) {
        setPage(page + 1);
        getUsersall();
      }
    }
  };

  const userSelected = (mail, id) => {
    //there's an issue with this function but it works for now, something is not right
    // var check = document.getElementById(`check-box${id}`);
    const checkAll = document.getElementById("checkAll");
    var check = document.getElementById(`${id}`);
    // console.log(!check.checked);
    if (!check.checked) {
      // console.log("not checked", check);
      // const newSelectedId = selectId.filter(element => {
      //  return element != id
      // })
      setSelectId(prev => {
        const newSet = new Set([...prev, id]);
        return Array.from(newSet);
      })

      // let remove = mail;

      // const selectedUser = selectedUsers.filter(function (item) {
      //   return item !== remove;
      // });
      // setSelectAll(mail);
      // setButtonEnabled(true);
      setDownloadBtn(true);
      setActiveButton(false);
      // console.log(selectId);
    } else {
      // setShowEditor(true);
      // setButtonEnabled(false);
      const newSelectedId = selectId.filter(element => {
        return element != id
      })
      //  console.log(newSelectedId);
      if (newSelectedId.length > 0) {
        setDownloadBtn(true);
      } else {
        setDownloadBtn(false);
        checkAll.checked = false;
      }
      setSelectId(newSelectedId)
      setActiveButton(true);
      selectedUsers.push(mail);
      selectId.push(id);
      // setDownloadBtn(true);
      setSelectAll(null);
    }
    // console.log(selectedUsers);
    // console.log(selectId);
  };
  useEffect(() => {
    const checkAll = document.getElementById("checkAll");
    // console.log(checkAll.checked);

    const handleCheckAll = (id) => {
      // console.log(!checkAll.checked);
      const checkboxes = document.getElementsByClassName(`checkbox`);
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = checkAll.checked;
        const mail = checkboxes[i].getAttribute("data-mail");
        // const id = checkboxes[i].getAttribute("data-id");
        const id = checkboxes[i].getAttribute("id");
        // console.log(id);


        if (checkAll.checked) {
          // selectId.push(id);
          setSelectId(prev => {
            // console.log(prev);
            const newSet = new Set([...prev, id]);
            return Array.from(newSet);
          })
          // console.log(selectId);
        } else {
          // const index = selectedUsers.indexOf(mail);
          // if (index !== -1) {
          //   setSelectedUsers((prevSelected) =>
          //     prevSelected.filter((item) => item !== mail)
          //   );
          // }
          setSelectId([])
        }
      }

      // setSelectId(selectId);
      setActiveButton(checkAll.checked);
      setDownloadBtn(checkAll.checked);
    };

    checkAll.addEventListener("click", handleCheckAll);


  }, [selectedUsers]);
  // console.log(selectId);

  // const doSearch = (e) => {
  //   setLoading(true);
  //   if (e.target.value === "") {
  //     //   getUsersall();
  //     //   getBatchB();
  //   } else {
  //     searchUser(e.target.value)
  //       .then((response) => response.data)
  //       .then((resp) => {
  //         // console.log(resp)
  //         if (resp?.data) {
  //           setUsers(resp.data);
  //           setLoading(false);
  //           setShowPagination(false);
  //         } else {
  //           toast.error("Search is currently unavailable");
  //         }
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error("Something went wrong. Try again!!");
  //         // window.location.reload();
  //       });
  //   }
  // };


  // console.log(selectId);

  // const url = `https://grazac-academy-admin.onrender.com/api/v1/admin/downloadWeb3?ids=${selectId}`;

  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function truncateStringWithExtension(str) {
    const lastDotIndex = str?.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return str?.length > 8 ? str?.slice(0, 8) + '...' : str;
    }

    const namePart = str?.slice(0, lastDotIndex);
    const extension = str?.slice(lastDotIndex);
    return namePart?.length > 8
      ? namePart?.slice(0, 8) + '...' + extension
      : str;
  }

  return (
    <div className="dashboard-content">
      <Popup
        show={showModal}
        formAction={formAction}
        handleClose={() => {
          setShowModal(false);
          setShowEditor(false);
        }}
        emails={selectedUsers}
      />
      <div>
        <h3>Hello Admin</h3>
        <div className="dashboard-content-top">
          <p>
            {day} {month} {date}, {year}
          </p>
          <div className="dashboard-content-search">
            <input
              type="text"
              placeholder="Search"
            // onChange={doSearch}
            />
            <img src={search} alt="search" />
          </div>
        </div>
        <div className="disp-flex">
          <p className="text1">
            IT Applicants
          </p>
          <div className="dashboard-content-actions">
            <div className="dashboard-content-actions-drop">
              <div
                className=" dashboard-content-actions-downloadBtn"
                style={{
                  backgroundColor: downloadBtn ? "#773DD3" : "#fff",
                }}
              >
                {/* <a href={url}>Export Details</a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-content-table">
          <table>
            <thead>
              <tr style={{ background: '#F5F8FF' }}>
                <th>
                  <label className="container">
                    <input type="checkbox" id="checkAll" />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th style={{ color: '#000' }}>Name</th>
                <th style={{ color: '#000' }}>Email Address</th>
                <th style={{ color: '#000' }}>Phone Number</th>
                <th style={{ color: '#000' }}>School</th>
                <th style={{ color: '#000' }}>ID Card</th>
                <th style={{ color: '#000' }}>Tution</th>
                <th style={{ color: '#000' }}>Date</th>

              </tr>
            </thead>
            <tbody>
              {!loading &&
                users?.map((item, idx) => {
                  // testData?.map((item, idx) => {
                  // console.log(item);

                  return (
                    <tr key={idx}>
                      <td>
                        <label className="container">
                          <input
                            type="checkbox"
                            id={item._id}
                            className="checkbox"
                          />
                          <span
                            className="checkmark"
                          ></span>
                        </label>
                      </td>

                      <td
                        onClick={() => {
                          navigate(`/it/itdetails?user=${item._id}`);
                        }}
                      >
                        {item.firstName} {item.lastName}
                      </td>
                      <td
                        onClick={() => {
                          navigate(`/it/itdetails?user=${item._id}`);
                        }}
                      >
                        {item.email}
                      </td>
                      <td
                        onClick={() => {
                          navigate(`/it/itdetails?user=${item._id}`);
                        }}
                      >
                        {item.phoneNumber}
                      </td>
                      <td
                        onClick={() => {
                          navigate(`/it/itdetails?user=${item._id}`);
                        }}

                      >
                        <span className="">{item.institution}</span>
                      </td>
                      <td>
                        <div className="socials">
                          <a href={item?.idCard} target="_blank" rel="noreferrer"><FaIdCard /></a>
                        </div>
                      </td>
                      <td
                        onClick={() => {
                          navigate(`/it/itdetails?user=${item._id}`);
                        }}

                      >
                        <span style={{
                          backgroundColor: item.isPaid ? '#20B15A1A' : '#3333331A',
                          color: item.isPaid ? '#20B15A' : '#333333',
                          padding: '2px 8px',
                          borderRadius: '100px',
                          fontSize: '12px',
                          fontWeight: '600'
                        }} >
                          {item.isPaid ? 'Paid' : 'Not Paid'}
                        </span>
                      </td>
                      <td
                      >
                        {formatDate(item.createdAt)}
                      </td>

                    </tr>
                  )
                })}
            </tbody>
          </table>
          {loading && (
            <img
              src={loader}
              alt="loader"
              style={{ width: "100px", margin: "50px auto", display: "block" }}
            />
          )}
          {showPagination && (
            <div className="disp-flex dashboard-content-table-pagination">
              <p>Rows per page: {users.length}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Itapplicants;
